import FormattedMessage from 'I18n/components/FormattedMessage';
import { Field } from 'react-final-form';
import UIFormControl from 'UIComponents/form/UIFormControl';
import { composeValidators } from '../utils/validation';
import styled from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledFormControl = styled(UIFormControl).withConfig({
  displayName: "FinalForm__StyledFormControl",
  componentId: "q669ar-0"
})(["", ""], props => props.hidden && 'display: none;');
const getMessage = (meta, formControlProps) => {
  if (meta.touched && meta.error) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.validation.${meta.error}`
    });
  } else {
    if (formControlProps && formControlProps.validationMessage) return formControlProps.validationMessage;
  }
  return null;
};
export const FinalFormField = ({
  render,
  formControlProps,
  fieldProps,
  validators,
  hidden
}) => {
  return /*#__PURE__*/_jsx(Field, Object.assign({}, fieldProps, {
    render: ({
      meta,
      input
    }) => /*#__PURE__*/_jsx(StyledFormControl, Object.assign({}, formControlProps, {
      error: !!(meta.touched && meta.error),
      hidden: hidden,
      validationMessage: getMessage(meta, formControlProps),
      children: render(input)
    })),
    validate: validators && composeValidators(...validators)
  }));
};